"use client";
import * as React from "react";
import styles from "./index.module.css";
import PencilIcon from "../icons/PencilIcon";
import CopytoClipboardIcon from "../icons/CopytoClipboardIcon";
import EyeIcon from "../icons/EyeIcon";
import EyeSlashIcon from "../icons/EyeSlashIcon";
import InfoIcon from "../icons/InfoIcon";
import LinkIcon from "../icons/LinkIcon";
import PlusIcon from "../icons/PlusIcon";
import CheckMarkIcon from "../icons/CheckMarkIcon";
import { IconButtonProps } from "../types";
import cssClassAssembler from "../../sso/utils/cssClassAssembler";

function IconButton(props: IconButtonProps) {
  function cssClasses() {
    return cssClassAssembler(props.classNames?.button, styles.btn);
  }

  return (
    <button
      type="button"
      onClick={(event) => props.handleClick(event)}
      className={cssClasses()}
      aria-label={props.label}
    >
      {props.icon === "PencilIcon" ? (
        <PencilIcon
          svgAttrs={{
            "aria-hidden": true,
            class: styles["svg"],
          }}
        />
      ) : null}
      {props.icon === "CopytoClipboardIcon" ? (
        <CopytoClipboardIcon
          svgAttrs={{
            "aria-hidden": true,
            class: styles["svg"],
          }}
        />
      ) : null}
      {props.icon === "EyeIcon" ? (
        <EyeIcon
          svgAttrs={{
            "aria-hidden": true,
            class: styles["svg"],
          }}
        />
      ) : null}
      {props.icon === "EyeSlashIcon" ? (
        <EyeSlashIcon
          svgAttrs={{
            "aria-hidden": true,
            class: styles["svg"],
          }}
        />
      ) : null}
      {props.icon === "InfoIcon" ? (
        <InfoIcon
          svgAttrs={{
            "aria-hidden": true,
            class: styles["svg"],
          }}
        />
      ) : null}
      {props.icon === "LinkIcon" ? (
        <LinkIcon
          svgAttrs={{
            "aria-hidden": true,
            class: styles["svg"],
          }}
        />
      ) : null}
      {props.icon === "PlusIcon" ? (
        <PlusIcon
          svgAttrs={{
            "aria-hidden": true,
            class: styles["svg"],
          }}
        />
      ) : null}
      {props.icon === "CheckMarkIcon" ? (
        <CheckMarkIcon
          svgAttrs={{
            "aria-hidden": true,
            class: styles["svg"],
          }}
        />
      ) : null}
    </button>
  );
}

export default IconButton;
